import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import ClientSelect from '../ClientSelect';
import CompanySelect from '../CompanySelect';
import AdditionalControlsInputLabel from './AdditionalControlsInputLabel';

const AdditionalAdvertiserControls = ({ clients, advertisers, shouldUnregister }) => {
  const { control } = useFormContext();

  return (
    <>
      <hr className='-mx-[32px] mt-8 mb-4' />
      <div className='mb-4'>
        <Typography id='advertiser-controls-titlex' variant='h5' component='div'>
          Advertiser
        </Typography>
        <span className='text-[#777E90] text-[12px]'>Assign the Client and advertiser to this user</span>
      </div>
      <div className='mb-3'>
        <AdditionalControlsInputLabel id='advertiser-client-select-label'>
          What Client does this advertiser user belong to?
        </AdditionalControlsInputLabel>
        <Controller
          name='client'
          defaultValue=''
          shouldUnregister={shouldUnregister}
          control={control}
          rules={{
            required: {
              value: true,
              message: 'Please select a Client.',
            },
          }}
          render={({ field, fieldState: { error } }) => (
            <ClientSelect
              {...field}
              labelId='advertiser-client-select-label'
              id='advertiser-client-select'
              options={clients}
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      </div>
      <div className='mb-3'>
        <AdditionalControlsInputLabel id='advertiser-advertiser-select-label'>
          Which Advertiser does this user belong to?
        </AdditionalControlsInputLabel>
        <Controller
          name='advertiser'
          shouldUnregister={shouldUnregister}
          control={control}
          defaultValue=''
          rules={{
            required: {
              value: true,
              message: 'Please select an Advertiser.',
            },
          }}
          render={({ field, fieldState: { error } }) => (
            <CompanySelect
              {...field}
              labelId='advertiser-advertiser-select-label'
              id='advertiser-advertiser-select'
              options={advertisers}
              placeholder='Select Advertiser'
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      </div>
    </>
  );
};

AdditionalAdvertiserControls.propTypes = {
  clients: PropTypes.array,
  advertisers: PropTypes.array,
  shouldUnregister: PropTypes.bool,
};

export default AdditionalAdvertiserControls;
